// extracted by mini-css-extract-plugin
export default {"content":"WeatherAndEnergyConsumptionContainer_content__Au8T4","headerContainer":"WeatherAndEnergyConsumptionContainer_headerContainer__0RAMt"};